import Layout from 'Layout'
import PublicLayout from 'Layout/PublicLayout'
import { ADMIN_URLS } from 'constans/urls'
import Login from 'pages/login'
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom'
import routes from 'routes'

const RouteProvider = () => {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route element={<PublicLayout />}>
          <Route
            key={ADMIN_URLS.LOGIN}
            path={ADMIN_URLS.LOGIN}
            element={<Login />}
          />
        </Route>
        <Route element={<Layout />}>
          {routes
            .filter(f => !f.path.includes(ADMIN_URLS.LOGIN))
            .map(r => (
              <Route key={r.path} path={r.path} element={<r.Element />} />
            ))}
        </Route>
      </Route>
    )
  )
  return <RouterProvider router={router} />
}

export default RouteProvider
